import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService as NgXTranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from "../services/translate.config.service";
import { ACTION_SUFFIX } from "../translate.suffix";
import { TranslatePipe } from "./translate.pipe";

@Pipe({
	name: 'cpActionTranslate',
	pure: true
})
export class ActionTranslatePipe implements PipeTransform, OnDestroy{
	public translate:TranslatePipe;

	constructor(private ng2TranslateService:NgXTranslateService,
				private changeDetectorRef:ChangeDetectorRef,
				private translateConfigService: TranslateConfigService) {
		this.translate = new TranslatePipe(ng2TranslateService, changeDetectorRef);
	}

	public ngOnDestroy(): void {
		this.translate.ngOnDestroy();
	}

	transform(query: string, ...args: any[]):any {
		return this.translateConfigService.containsRegisteredTranslateSuffix(query) ?
			this.translate.transform(query, ...args) :
			this.translate.transform(query + ACTION_SUFFIX, ...args);
	}
}
